// import gsap from 'gsap'
// import ScrollTrigger from 'gsap/ScrollTrigger'
// import ScrollToPlugin from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class HeaderMenu {
  constructor(_targetElem, _motionElems) {
    this.scrollTop = document.documentElement.scrollTop;
    this.headerHideFlag = false;
    this.headerMenuTimeout;
    this.headerMenuElem = document.querySelector("#js-header-menu");
    this.wrapperElem = document.querySelector("#js-wrapper");
    this.headerAssetsSpElem = document.querySelector("#js-header-assets-sp");

    this.headerCloseElem = document.querySelector("#js-header-close");

    this.headerEntryElem = document.querySelector("#js-header-entry");
    this.headerEntryTimeout;

    this.excute();
  }

  excutePageLink = (_target) => {
    gsap.to(window, {
      duration: 1,
      ease: "power4.inOut",
      delay: 0,
      scrollTo: {
        y: _target,
        autoKill: false,
        // offsetY: 0,
        // offsetY:() =>  getOffsetY(),
      },
      onComplete: () => {},
    });
  };

  excute = () => {
    const _this = this;
    // this.drawerElems = document.querySelectorAll('.js-drawer-link')
    // this.drawerElems.forEach((drawerElem) => {
    //   const drawerClick = (e) => {
    //     if (document.body.classList.contains('is-active-menu')) {
    //       document.body.classList.add('is-active-menu-hide')
    //       if(_this.headerHideFlag) document.body.classList.add('is-header-hide')
    //       _this.headerMenuTimeout = setTimeout(function () {
    //         htmlElem.classList.remove('is-active-menu')
    //         document.body.classList.remove('is-active-menu-hide')
    //         document.body.classList.remove('is-active-menu')
    //         // window.scrollTo(0, _this.scrollTop)
    //         // _this.wrapperElem.style.top = 0 + 'px'
    //         // setTimeout(function () {
    //         //   if(_this.headerHideFlag) document.body.classList.add('is-header-hide')

    //         //   // alert(drawerElem.getAttribute("href"))
    //         //   var thisHref = drawerElem.getAttribute("href")
    //         //   const last = thisHref.lastIndexOf('#');
    //         //   const anchor = "#" + thisHref.slice(last + 1);
    //         //   //href="/faculty/curriculum/learning.html#sec01"
    //         //   // var anchor = document.querySelector( location.hash );
    //         //   gsap.to(window, {
    //         //     duration: 0.6,
    //         //     ease: 'power4.inOut',
    //         //     delay: 0,
    //         //     scrollTo: {
    //         //       y: anchor,
    //         //       autoKill: false,
    //         //       // offsetY: getOffsetY(),
    //         //       // offsetY:() =>  getOffsetY(),
    //         //     },
    //         //     onComplete: () => {},
    //         //   })
    //         // }, 10)
    //         // setTimeout(function () {
    //         //   document.body.classList.remove('is-event-false')
    //         // }, 500)
    //       }, 500) //500
    //     }
    //   }
    //   drawerElem.addEventListener('click', drawerClick)
    // })

    // this.drawerLinks = document.querySelectorAll('.js-drawer-link')
    // this.drawerLinks.forEach((smoothLink) => {
    //   smoothLink.addEventListener('click', (e) => {
    //     e.preventDefault()
    //     if (document.body.classList.contains('is-active-menu')) {
    //       document.body.classList.add('is-active-menu-hide')
    //       // if(_this.headerHideFlag) document.body.classList.add('is-header-hide')
    //       setTimeout(function () {
    //         // htmlElem.classList.remove('is-active-menu')
    //         document.body.classList.remove('is-active-menu-hide')
    //         document.body.classList.remove('is-active-menu')
    //         window.scrollTo(0, _this.scrollTop)
    //         _this.wrapperElem.style.top = 0 + 'px'
    //         setTimeout(function () {
    //           _this.excutePageLink(smoothLink.getAttribute('href'))
    //         }, 100)
    //       }, 500)
    //     } else {
    //       _this.excutePageLink(smoothLink.getAttribute('href'))
    //     }
    //   })
    // })

    this.headerCloseElem.addEventListener("click", function (e) {
      e.preventDefault();

      document.body.classList.add("is-event-false");
      document.body.classList.add("is-active-menu-hide");
      if (_this.headerHideFlag) document.body.classList.add("is-header-hide");
      _this.headerMenuTimeout = setTimeout(function () {
        // htmlElem.classList.remove('is-active-menu')
        document.body.classList.remove("is-active-menu-hide");
        document.body.classList.remove("is-active-menu");
        window.scrollTo(0, _this.scrollTop);
        _this.wrapperElem.style.top = 0 + "px";
        setTimeout(function () {
          if (_this.headerHideFlag)
            document.body.classList.add("is-header-hide");
        }, 10);
        setTimeout(function () {
          // document.body.classList.remove('is-active-menu-hack')
          document.body.classList.remove("is-event-false");
        }, 500);
      }, 500); //500
    });

    // let htmlElem = document.querySelector('html')
    this.headerMenuElem.addEventListener("click", function (e) {
      e.preventDefault();
      document.body.classList.add("is-event-false");
      if (!document.body.classList.contains("is-active-menu")) {
        // if (!_this.headerEntryElem.classList.contains('is-entry-active-menu')) {
        if (_this.headerEntryElem.classList.contains("is-entry-active")) {
          _this.headerEntryElem.classList.add("is-entry-hide");
          _this.headerEntryTimeout = setTimeout(function () {
            _this.headerEntryElem.classList.remove("is-entry-active");
            _this.headerEntryElem.classList.remove("is-entry-hide");
          }, 0);
        }
        // }

        _this.headerHideFlag = false;
        // console.log(document.body.getAttribute("class"))
        if (document.body.classList.contains("is-header-hide"))
          _this.headerHideFlag = true;
        _this.scrollTop = document.documentElement.scrollTop;
        document.body.classList.add("is-active-menu");
        // document.body.classList.add('is-active-menu-hack')

        // htmlElem.classList.add('is-active-menu')
        _this.wrapperElem.style.top = -_this.scrollTop + "px";
        window.scrollTo(0, 0);
        _this.headerAssetsSpElem.scrollTo(0, 0);
        document.body.classList.remove("is-event-false");
        // setTimeout(function () {
        // if(_this.headerHideFlag) document.body.classList.add('is-hero-hide')
        // }, 10)
      } else {
        document.body.classList.add("is-active-menu-hide");
        if (_this.headerHideFlag) document.body.classList.add("is-header-hide");
        _this.headerMenuTimeout = setTimeout(function () {
          // htmlElem.classList.remove('is-active-menu')
          document.body.classList.remove("is-active-menu-hide");
          document.body.classList.remove("is-active-menu");
          window.scrollTo(0, _this.scrollTop);
          _this.wrapperElem.style.top = 0 + "px";
          setTimeout(function () {
            if (_this.headerHideFlag)
              document.body.classList.add("is-header-hide");
          }, 10);
          setTimeout(function () {
            // document.body.classList.remove('is-active-menu-hack')
            document.body.classList.remove("is-event-false");
          }, 500);
        }, 500); //500
      }
    });
  };
}
